// web-staking-estimator-frontend/src/components/common/FormField.js
import React from "react";

/**
 * Reusable form field component for consistent label + input patterns
 */
export function FormField({
  label,
  required = false,
  value,
  onChange,
  placeholder,
  inputMode,
  autoComplete,
  pattern,
  ariaLabel,
  type = "text",
}) {
  return (
    <>
      <label className="formLabel">
        {label}
        {required && "*"}
      </label>
      <input
        className="formInput"
        type={type}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        inputMode={inputMode}
        autoComplete={autoComplete}
        pattern={pattern}
        aria-label={ariaLabel || label}
      />
    </>
  );
}
